<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('borrowingSparePartClaim.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('borrowingSparePartClaim.pageTitle'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div
          class="
            d-flex
            justify-content-between
            ts-items-center ts-whitespace-no-wrap ts-space-x-3
          "
        >
          <div class="ts-flex ts-items-center ts-space-x-3">
            <a-range-picker
              v-model="dateRange"
              :allowClear="false"
              format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
              style="width: 200px"
              @change="fetchData()"
            />
          </div>
          <div class="d-flex ts-space-x-3 ts-items-center">
            <ts-input
              v-tooltip="$t('borrowingSparePartClaim.search')"
              v-model="search"
              :placeholder="$t('borrowingSparePartClaim.search')"
              style="width: 250px"
              class="inline-block"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">
              {{ record.branch_name_en }}
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.service_date }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.sfo_number }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.borrowing_ref }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.invoice_no }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.reference_claim }}</td>
            <td class="ts-whitespace-no-wrap">
              {{ record.discount_reference }}
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.reference_prq }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.service_type }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.customer_name }}</td>
            <td class="ts-whitespace-no-wrap">
              {{ record.customer_name_invioce }}
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.engine_number }}</td>
            <td class="ts-whitespace-no-wrap ts-text-right">
              {{
                $formatNumber(
                  sumDiscountAmount(record.details) * record.fx_rate_khr
                )
              }}
              ៛
            </td>
            <td class="ts-whitespace-no-wrap ts-text-right">
              {{
                $formatNumber(
                  sumTotalAmount(record.details) * record.fx_rate_khr
                )
              }}
              ៛
            </td>
            <td class="text-center ts-space-x-3 ts-whitespace-no-wrap">
              <a
                href="#"
                v-tooltip="$t('claim')"
                class="text-primary"
                @click.prevent="showFormRef(record)"
              >
                <i class="fas fa-hand-holding-usd"></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
      <a-modal
        :title="$t('borrowingSparePartClaim.updateReference')"
        width="300px"
        v-model="show_form_ref"
        :footer="null"
      >
        <ts-loading-banner :loading="saving_update">
          <div class="ts-space-y-2">
            <div class="row">
              <div class="col-md-12">
                <label>{{ $t('borrowingSparePartClaim.referenceClaim') }}</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="model.reference_claim"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label>{{ $t('borrowingSparePartClaim.referenceDiscount') }}</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="model.discount_reference"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label>{{ $t('borrowingSparePartClaim.referencePRQ') }}</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="model.reference_prq"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 ts-flex ts-space-x-2 ts-justify-end">
                <ts-button @click.prevent="() => (show_form_ref = false)">{{
                  $t('cancel')
                }}</ts-button>
                <ts-button @click.prevent="updateReference" color="primary">{{
                  $t('save')
                }}</ts-button>
              </div>
            </div>
          </div>
        </ts-loading-banner>
      </a-modal>
    </ts-card>
  </div>
</template>
<script>
import { debounce, sumBy } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'borrowingSparePartClaim',
  data() {
    return {
      loading: false,
      show_form_ref: false,
      saving_update: false,
      model: {
        sfo_id: null,
        reference_claim: '',
        discount_reference: '',
        reference_prq: '',
      },
    }
  },
  computed: {
    ...mapState('wholesale/borrowingSparePartClaim', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.wholesale.borrowingSparePartClaim.search
      },
      set(newValue) {
        this.$store.commit('wholesale/borrowingSparePartClaim/SET_SEARCH', newValue)
        this.$store.commit('wholesale/borrowingSparePartClaim/RESET_CURRENT_PAGE')
      },
    },
    dateRange: {
      get() {
        return this.$store.state.wholesale.borrowingSparePartClaim.dateRange
      },
      set(newValue) {
        this.$store.commit(
          'wholesale/borrowingSparePartClaim/SET_DATE_RANGE',
          newValue
        )
      },
    },
    columns() {
      return [
        { name: this.$t('borrowingSparePartClaim.branchName') },
        { name: this.$t('borrowingSparePartClaim.serviceDate') },
        { name: this.$t('borrowingSparePartClaim.borrowingNumber') },
        { name: this.$t('borrowingSparePartClaim.borrowingRef') },
        { name: this.$t('borrowingSparePartClaim.invoiceRef') },
        { name: this.$t('borrowingSparePartClaim.referenceClaim') },
        { name: this.$t('borrowingSparePartClaim.referenceDiscount') },
        { name: this.$t('borrowingSparePartClaim.referencePRQ') },
        { name: this.$t('borrowingSparePartClaim.serviceType') },
        { name: this.$t('borrowingSparePartClaim.customer') },
        { name: this.$t('borrowingSparePartClaim.customerInvoice') },
        { name: this.$t('borrowingSparePartClaim.engineNumber') },
        {
          name: this.$t('borrowingSparePartClaim.discountAmount'),
          style: 'text-align:right',
        },
        {
          name: this.$t('borrowingSparePartClaim.amount'),
          style: 'text-align:right',
        },
        {
          name: this.$t('actions'),
          style: 'text-align:center; width:7%',
        },
      ]
    },
  },
  methods: {
    sumTotalAmount(details = []) {
      return sumBy(details, (o) => {
        let amount = o.sale_price * (o.quantity_order - o.quantity_return)
        return amount - (amount * o.discount_rate) / 100
      })
    },
    sumDiscountAmount(details = []) {
      return sumBy(details, (o) => {
        let amount = o.sale_price * (o.quantity_order - o.quantity_return)
        return (amount * o.discount_rate) / 100
      })
    },
  
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('wholesale/borrowingSparePartClaim/fetch', { ...attributes })
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    branchFilter(value) {
      this.$store.commit('wholesale/borrowingSparePartClaim/SET_BRANCH_ID', value)
      this.fetchData()
    },
    showFormRef(record) {
      this.show_form_ref = true
      this.model.sfo_id = record.sfo_id
      this.model.reference_claim = record.reference_claim
      this.model.discount_reference = record.discount_reference
      this.model.reference_prq = record.reference_prq
    },
    updateReference() {
      this.saving_update = true
      this.$store
        .dispatch('wholesale/borrowingSparePartClaim/updateRef', {
          id: this.model.sfo_id,
          data: this.model,
        })
        .then((response) => {
          this.$toasted.success(response.message)
          this.fetchData()
          this.show_form_ref = false
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.saving_update = false
        })
    },
  },
  watch: {
    search: debounce(function () {
      this.fetchData()
    }, 500),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData()
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('wholesale/borrowingSparePartClaim/RESET_STATE')
    next()
  },
}
</script>
